import { useMutation } from '@tanstack/react-query';
import { vehicleApi } from '../api/vehicleApi';
import { notifications } from '@/utils/notifications';

/**
 * Hook pour la recherche de véhicule via SIVIN
 */
export const useVehicleSearch = () => {
  return useMutation({
    mutationFn: ({
      searchValue,
      type,
      societyId,
    }: {
      searchValue: string;
      type: 1 | 2;
      societyId?: string;
    }) => vehicleApi.searchVehicle(searchValue, type, societyId),
    onError: (error: any) => {
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message;

      if (status === 401) {
        notifications.error(
          'Erreur d\'authentification SIVIN. Contactez l\'administrateur.',
        );
      } else if (status === 403) {
        if (message.includes('IP')) {
          notifications.error(
            'Votre IP n\'est pas autorisée à accéder à l\'API SIVIN. Contactez l\'administrateur.',
          );
        } else {
          notifications.error(
            'Quota SIVIN API dépassé. Contactez l\'administrateur.',
          );
        }
      } else if (status === 429) {
        notifications.warning(
          'Quota de recherches société dépassé. Veuillez saisir les informations manuellement.',
        );
      } else if (status === 404) {
        notifications.warning(
          'Véhicule non trouvé. Veuillez saisir les informations manuellement.',
        );
      } else {
        notifications.error(`Erreur lors de la recherche : ${message}`);
      }
    },
  });
};
